import DocsService from '@/services/docs.service'

export default {
  namespaced: true,
  state: {
    docs: [],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setDocs: (state, docs) => state.docs = docs,
  },
  actions: {
    async ['buscaDocs']({ commit },
      {
        uf,
        produto,
        tipo_plano,
        contratacao,
        administradora,
        entidade
      }
    ) {
      try {
        commit('setLoading', true)
        const data = await DocsService.busca(
          uf,
          produto,
          tipo_plano,
          contratacao,
          administradora,
          entidade
        )
        commit('setDocs', data)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getDocs: state => state.docs,
  }
}
